import * as React from "react"

const SearchSvg = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="#707070"
        {...props}
        viewBox={'0 0 16 16'}
    >
        <g clipPath="url(#a)">
            <path
                fill="inherit"
                stroke={'none'}
                fillRule="evenodd"
                d="m11.46 10.319 4.304 4.304a.807.807 0 0 1-1.142 1.14L10.32 11.46a6.4 6.4 0 1 1 1.141-1.141Zm-5.06.88a4.8 4.8 0 1 0 0-9.599 4.8 4.8 0 0 0 0 9.6Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" stroke={'none'} d="M0 0h16v16H0z"/>
            </clipPath>
        </defs>
    </svg>
)

export default SearchSvg